module.exports = __webpack_public_path__ + "media/images/flags/JM-cec9155a3be0fdfd7a8a7acf9c1b1733.svg";